// @ts-nocheck
/* eslint-disable */

import axios from 'axios';
import {getHostApi, getRequestConfig} from "../../../utils";
import {getUserId, sessionExpire} from "../MonCompteAction";
import {Cart} from "../iMonCompte";


export function canValidate(idCommande: string) {
  return axios.get(`${getHostApi()}/customers/${getUserId()}/orders/${idCommande}/is-files-completed`,
    getRequestConfig()).then((response) => {
    return response.data && response.data.canValidate;
  }).catch((error) => {
    if(error.response && error.response.status && error.response.status === 401) {
      sessionExpire();
    }
    console.log(error);
  });
}

export function getFile(idCommande: string, idCaddies: string, surfaceId: string, emplacementId: string) {
  return axios.get(`${getHostApi()}/customers/${getUserId()}/orders/${idCommande}/items/${idCaddies}/surfaces/${surfaceId}/locations/${emplacementId}/images`,
    getRequestConfig()).then((response) => {
      if(response && response.status == 200) {
        return response;
      }
  }).catch((error) => {
    if(error.response && error.response.status && error.response.status === 401) {
      sessionExpire();
    }
    console.log(error);
  });
}

export function getUploadRequest(url: string, config: any = {...getRequestConfig()}) {
  return axios.get(url,config).then((response) => {
    if(response && response.status == 200) {
      return response;
    }
  }).catch((error) => {
    if(error.response && error.response.status && error.response.status === 401) {
      sessionExpire();
    }
    console.log(error);
  });
}

export function postUploadRequest(url: string,  data: any, config: any = {...getRequestConfig()}) {
  return axios.post(url,data,config).then((response) => {
    return response;
  }).catch((error) => {
    if(error.response && error.response.status && error.response.status === 401) {
      sessionExpire();
    }
    else if(error.response.status === 400 && error.response.data.message) {
     return error.response.data.message;
    }
    else {
      return 'Une erreur s\'est produite';
    }
    console.log(error);
  });
}

export function putUploadRequest(url: string,  data: any, config: any = {...getRequestConfig()}) {
  return axios.put(url,data,config).then((response) => {
    return response;
  }).catch((error) => {
    if(error.response && error.response.status && error.response.status === 401) {
      sessionExpire();
    }
    console.log(error);
  });
}

export function deleteUploadRequest(url: string) {
  return axios.delete(url,
    getRequestConfig()).then((response) => {
    return response;
  }).catch((error) => {
    if(error.response && error.response.status && error.response.status === 401) {
      sessionExpire();
    }
    console.log(error);
  });
}

export function canGallerie(idCommande: string, data: any) {
  return axios.post(`${getHostApi()}/customers/${getUserId()}/orders/${idCommande}/can-upload-galerie`,
    data
    , getRequestConfig()).then((response) => {
    return response.data && response.data.canGalerie;
  }).catch((error) => {
    if(error.response && error.response.status && error.response.status === 401) {
      sessionExpire();
    }
    console.log(error);
  });
}

export function deleteTexture(creationId: string, idCommande: number) {
  const url = `${getHostApi()}/customers/${getUserId()}/galleries/orders/${idCommande}/remove-texture/${creationId}`;
  return axios.delete(url,
    getRequestConfig()).then((response) => {
    return response;
  }).catch((error) => {
    if(error.response && error.response.status && error.response.status === 401) {
      sessionExpire();
    }
    console.log(error);
  });
}